export default function(state = {}, action) {
  const typeMap = {
    WORLD_CHANGING_IDEAS_PAGE_LOADING() {
      return {
        isLoading: true,
        worldChangingIdeasPage: action.worldChangingIdeasPage
      };
    },
    WORLD_CHANGING_IDEAS_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.worldChangingIdeasPage
      };
    },
    WORLD_CHANGING_IDEAS_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.worldChangingIdeasPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
